import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const DashboardLayout = ({ children, currentUser, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = currentUser?.role === 'admin' ? '/admin' : '/users';
  const logoutPath = currentUser?.role === 'admin' ? '/admin/signout' : '/users/signout';

  const handleLogoutClick = async () => {
    if (onLogout) {
      await onLogout(logoutPath);
    }
  };

  const styles = {
    container: {
      display: 'flex',
      minHeight: '100vh',
      backgroundColor: '#f8f9fa'
    },
    sidebar: {
      width: '250px',
      backgroundColor: '#033547',
      color: 'white',
      padding: '2rem 0',
      position: 'fixed',
      height: '100vh',
      overflowY: 'auto'
    },
    logo: {
      padding: '0 1.5rem',
      marginBottom: '2rem',
      borderBottom: '1px solid #34495e',
      paddingBottom: '1rem',
      textAlign: 'center'
    },
    logoImg: {
      maxWidth: '180px',
      height: 'auto',
      display: 'block',
      margin: '0 auto'
    },
    logoText: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      marginTop: '0.5rem',
      textAlign: 'center'
    },
    nav: {
      listStyle: 'none',
      padding: 0,
      margin: 0
    },
    navItem: {
      padding: '0.75rem 1.5rem',
      cursor: 'pointer',
      transition: 'background 0.2s, border-left 0.2s',
      textDecoration: 'none',
      color: 'white',
      display: 'block',
      borderLeft: '4px solid transparent'
    },
    navItemActive: {
      backgroundColor: '#016e8c',
      borderLeft: '4px solid #10b981',
      fontWeight: 'bold'
    },
    navItemHover: {
      backgroundColor: '#34495e'
    },
    main: {
      marginLeft: '250px',
      flex: 1,
      padding: '2rem'
    },
    header: {
      backgroundColor: 'white',
      padding: '1.5rem',
      marginBottom: '2rem',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    userInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem'
    },
    badge: {
      backgroundColor: '#016e8c',
      color: 'white',
      padding: '0.25rem 0.75rem',
      borderRadius: '12px',
      fontSize: '0.875rem',
      fontWeight: 'bold'
    },
    logoutBtn: {
      padding: '0.5rem 1rem',
      backgroundColor: '#6c757d',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.sidebar}>
        <div style={styles.logo}>
          <img src="/bluecoding-logo.png" alt="Blue Coding" style={styles.logoImg} />
          <div style={styles.logoText}>SurveyPilot</div>
        </div>
        <ul style={styles.nav}>
          <li>
            <Link 
              to={`${basePath}/dashboard`} 
              style={{
                ...styles.navItem,
                ...(location.pathname.endsWith('/dashboard') ? styles.navItemActive : {})
              }}
            >
              Dashboard
            </Link>
          </li>
          <li>
            <Link 
              to={`${basePath}/surveys`} 
              style={{
                ...styles.navItem,
                ...(location.pathname.includes('/surveys') && !location.pathname.includes('/surveys/new') && !location.pathname.includes('/surveys/') ? styles.navItemActive : {})
              }}
            >
              Surveys
            </Link>
          </li>
          {currentUser?.role === 'admin' && (
            <>
              <li>
                <Link 
                  to={`${basePath}/surveys/new`} 
                  style={{
                    ...styles.navItem,
                    ...(location.pathname.includes('/surveys/new') ? styles.navItemActive : {})
                  }}
                >
                  Create Survey
                </Link>
              </li>
              <li>
                <Link 
                  to={`${basePath}/managers`} 
                  style={{
                    ...styles.navItem,
                    ...(location.pathname.includes('/managers') ? styles.navItemActive : {})
                  }}
                >
                  Managers
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
      <div style={styles.main}>
        <div style={styles.header}>
          <div style={styles.userInfo}>
            <span>Welcome, <strong>{currentUser?.email}</strong></span>
            <span style={styles.badge}>{currentUser?.role?.toUpperCase()}</span>
          </div>
          <button onClick={handleLogoutClick} style={styles.logoutBtn}>
            Logout
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout;
